import moment from "moment";
import React from "react";
import { matchPath, useHistory, useLocation } from "react-router-dom";
import { useAuthentication } from "../../../context/authentication";
import { useCommissionReports } from "../../../context/commissionReports";
import { DottedMenu } from "../../../context/dropdownMenu/DropdownMenuProvider";
import { useToast } from "../../../context/toast";
import { downloadFile } from "../../../utils/csv";
import { CommissionReport } from "../../../utils/types";

interface Props {
  disabled?: boolean;
  commissionReport: CommissionReport;
}

const CommissionReportActionsButton: React.FC<Props> = ({
  disabled,
  commissionReport
}) => {
  const { setModalWarningConfig } = useToast();
  const { wrapActionWithAuth } = useAuthentication();
  const { removeCommissionReport } = useCommissionReports();
  const browserLocation = useLocation();
  const history = useHistory();

  const detailsPageMatch = matchPath<{
    id: string;
  }>(browserLocation.pathname, {
    path: "/workspace/commission-reports/:id"
  });

  return (
    <DottedMenu
      disabled={disabled}
      text="Open commission report actions"
      menuItems={[
        {
          text: "Download raw JSON data",
          onClick: () => {
            downloadFile(
              JSON.stringify(commissionReport, null, 2),
              `commission-report-${commissionReport.identifier}-data-${moment()
                .utc()
                .format("YYYY_MM_DD_HH_mm")}.json`,
              "application/json"
            );
          }
        },
        {
          text: "Remove commission report",
          onClick: wrapActionWithAuth(() => {
            setModalWarningConfig({
              open: true,
              resolve: () => {
                removeCommissionReport(commissionReport.uuid);

                if (detailsPageMatch?.params?.id === commissionReport.uuid) {
                  history.push("/workspace/commission-reports");
                }
              }
            });
          })
        }
      ]}
    />
  );
};

export default CommissionReportActionsButton;
